// extracted by mini-css-extract-plugin
export default {"search__block":"Search_search__block__mCSa9","active":"Search_active__mvXU1"};